import script from "./UserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=69d54def&lang=scss&scoped=true"

import exportComponent from "D:\\NET\\AsdCare\\asdcare-internal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69d54def"]])

export default __exports__